import { render } from "./Redirect.vue?vue&type=template&id=e608cd16&ts=true"
import script from "./Redirect.vue?vue&type=script&lang=ts"
export * from "./Redirect.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__